module.exports = __webpack_public_path__ + "img/discount.92a85a07.svg";